import { Modal as ModalModule } from 'common';
import React from 'react';

const { Modal, ModalButtonActionType } = ModalModule;

const DeletePaymentModal = props => {
	const { modalId } = props;

	const renderMessage = () => {
		const {
			data: { selectedCount },
		} = props;

		return selectedCount > 1
			? `Delete ${selectedCount} Payment Methods?`
			: 'Delete this Payment Method?';
	};

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Yes',
		dataqa: 'delete-payment-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-payment-no-button',
	};

	return (
		<Modal
			modalId={modalId}
			header="Delete Payment Method"
			className="account-payment delete-payment-modal"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<p>
				<span className="warning-icon pi pi-exclamation-triangle" />
				{renderMessage()}
			</p>
		</Modal>
	);
};

export default DeletePaymentModal;
